
import Vue from "vue";
import { IBillingInfo, IStateProvince } from "../types";
import { STATE_PROVINCE } from "../constants/StateProvince";
import { mapGetters } from "vuex";
import store from "../store";
//@ts-ignore
import maskit from "../util/maskit";
//@ts-ignore
import tokens from "../util/tokens";
import fieldEntryMixin from "@/components/mixins/fieldEntryMixin.vue";

export default Vue.extend({
  name: "billing-review",
  mixins: [fieldEntryMixin],
  data: function() {
    return {
      maskPhone: "" as string
    };
  },
  computed: {
    billingInfo(): any {
      //@ts-ignore
      return store.getters.billingModule.getBilling;
    },
    phoneNumberMasked(): string {
      //@ts-ignore
      return maskit(this.billingInfo.phone, this.masks.phoneMask, true, tokens);
    },
    stateName(): string {
      //@ts-ignore
      let state: IStateProvince = STATE_PROVINCE.find(
        s => s.code === this.billingInfo.state
      );

      return state.name;
    }
  }
});
